// extracted by mini-css-extract-plugin
module.exports = {"duelCreationModal":"DuelCreationModal_duelCreationModal__gtJlu","gameModeFormGroup":"DuelCreationModal_gameModeFormGroup__1Bot0"};